// ═══════════════════════════════════════════════════════════
//  DWB Tech – Festival & Holiday Theme Engine
//  Covers all holidays from the 2026 DWB Holiday List
//  + "Today" detection for DWB Family Day / Team Day
// ═══════════════════════════════════════════════════════════

const FESTIVALS = [
  // ── PONGAL (3 days) ──────────────────────────────────────
  {
    name: 'Pongal',
    dates: ['01-14', '01-15', '01-16'],
    emoji: ['🌾', '🎑', '🪔'],
    image: '🌾',
    banner: '🌾 Pongal Vazhthukkal! Wishing you a harvest of joy & prosperity!',
    bannerBg: 'linear-gradient(90deg, #b45309, #d97706, #f59e0b)',
    gradient: 'linear-gradient(90deg, #fde68a, #fbbf24, #f59e0b)',
    textColor: '#fff',
    particleType: 'sugarcane',   // sugarcane / rice particles
    theme3d: 'pongal',
    particles: ['🌾', '🌺', '🎑', '🪔', '🌻'],
    bgOverlay: 'rgba(180,83,9,0.18)',
    accentColor: '#f59e0b',
    glowColor: 'rgba(245,158,11,0.6)',
  },

  // ── REPUBLIC DAY ─────────────────────────────────────────
  {
    name: 'Republic Day',
    dates: ['01-26'],
    emoji: ['🇮🇳', '🎡', '✨'],
    image: '🇮🇳',
    banner: '🇮🇳 Happy Republic Day! Jai Hind! Proud to be Indian!',
    bannerBg: 'linear-gradient(90deg, #FF9933, #fff, #138808)',
    gradient: 'linear-gradient(90deg, #FF9933, #138808)',
    textColor: '#000080',
    particleType: 'tricolor',
    theme3d: 'republic',
    particles: ['🇮🇳', '🎡', '⭐', '🕊️', '🎊'],
    bgOverlay: 'rgba(255,153,51,0.12)',
    accentColor: '#FF9933',
    glowColor: 'rgba(255,153,51,0.7)',
  },

  // ── LABOUR DAY ────────────────────────────────────────────
  {
    name: 'Labour Day',
    dates: ['05-01'],
    emoji: ['⚙️', '💪', '🛠️'],
    image: '⚙️',
    banner: '⚙️ Happy Labour Day! Celebrating the strength & dedication of every worker!',
    bannerBg: 'linear-gradient(90deg, #991b1b, #dc2626, #ef4444)',
    gradient: 'linear-gradient(90deg, #fca5a5, #f87171, #ef4444)',
    textColor: '#fff',
    particleType: 'gear',
    theme3d: 'labour',
    particles: ['⚙️', '🔧', '💪', '🛠️', '⭐'],
    bgOverlay: 'rgba(220,38,38,0.15)',
    accentColor: '#ef4444',
    glowColor: 'rgba(239,68,68,0.6)',
  },

  // ── DWB FAMILY DAY ────────────────────────────────────────
  {
    name: 'DWB Family Day',
    dates: ['05-31'],
    emoji: ['🎉', '👨‍👩‍👧‍👦', '🎊'],
    image: '🎉',
    banner: '🎉 Happy DWB Family Day! Together we grow, together we shine! 🌟',
    bannerBg: 'linear-gradient(90deg, #1a3c5e, #2563a8, #4a90d9)',
    gradient: 'linear-gradient(90deg, #7ec8f7, #4a90d9, #2563a8)',
    textColor: '#fff',
    particleType: 'confetti',
    theme3d: 'familyday',
    particles: ['🎉', '🎊', '⭐', '💙', '🌟', '🎈'],
    bgOverlay: 'rgba(37,99,168,0.2)',
    accentColor: '#4a90d9',
    glowColor: 'rgba(74,144,217,0.8)',
    isDWBSpecial: true,   // extra 3D logo effect
  },

  // ── INDEPENDENCE DAY ──────────────────────────────────────
  {
    name: 'Independence Day',
    dates: ['08-15'],
    image: '🇮🇳',
    emoji: ['🇮🇳', '🕊️', '🎆'],
    banner: '🇮🇳 Happy Independence Day! Freedom, Pride & Unity! Jai Hind! 🕊️',
    bannerBg: 'linear-gradient(90deg, #FF9933, #fff 50%, #138808)',
    gradient: 'linear-gradient(90deg, #FF9933, #138808)',
    textColor: '#000080',
    particleType: 'tricolor',
    theme3d: 'independence',
    particles: ['🇮🇳', '🕊️', '🎆', '⭐', '🎊'],
    bgOverlay: 'rgba(255,153,51,0.12)',
    accentColor: '#FF9933',
    glowColor: 'rgba(255,153,51,0.7)',
  },

  // ── VINAYAKAR CHATHURTHI ──────────────────────────────────
  {
    name: 'Vinayakar Chathurthi',
    dates: ['09-14'],
    image: '🐘',
    emoji: ['🐘', '🪔', '🌺'],
    banner: '🐘 Vinayakar Chathurthi Vazhthukkal! May Lord Ganesha bless DWB family! 🌺',
    bannerBg: 'linear-gradient(90deg, #7c3aed, #a855f7, #c084fc)',
    gradient: 'linear-gradient(90deg, #f5d0fe, #e879f9, #a855f7)',
    textColor: '#fff',
    particleType: 'flowers',
    theme3d: 'ganesha',
    particles: ['🐘', '🌺', '🪔', '🌸', '🎊'],
    bgOverlay: 'rgba(168,85,247,0.18)',
    accentColor: '#a855f7',
    glowColor: 'rgba(168,85,247,0.7)',
  },

  // ── GANDHI JAYANTHI ───────────────────────────────────────
  {
    name: "Gandhi Jayanthi",
    dates: ['10-02'],
    image: '🐘',
    emoji: ['🕊️', '🇮🇳', '✌️'],
    banner: '🕊️ Gandhi Jayanthi — Remembering the Father of the Nation. Truth & Non-violence forever.',
    bannerBg: 'linear-gradient(90deg, #064e3b, #065f46, #059669)',
    gradient: 'linear-gradient(90deg, #6ee7b7, #34d399, #059669)',
    textColor: '#fff',
    particleType: 'peace',
    theme3d: 'gandhi',
    particles: ['🕊️', '✌️', '🌿', '🎡', '⭐'],
    bgOverlay: 'rgba(5,150,105,0.15)',
    accentColor: '#059669',
    glowColor: 'rgba(5,150,105,0.6)',
  },

  // ── VIJAYA DASAMI / AYUTHA POOJA (2 days) ────────────────
  {
    name: 'Vijaya Dasami',
    dates: ['10-20', '10-21'],
    image: '⚔️',
    emoji: ['⚔️', '🏆', '🌺'],
    banner: '⚔️ Vijaya Dasami & Ayutha Pooja Vazhthukkal! Victory & prosperity to all! 🏆',
    bannerBg: 'linear-gradient(90deg, #92400e, #b45309, #d97706)',
    gradient: 'linear-gradient(90deg, #fde68a, #f59e0b, #d97706)',
    textColor: '#fff',
    particleType: 'gold',
    theme3d: 'vijayadasami',
    particles: ['⚔️', '🏆', '🌺', '🎊', '⭐'],
    bgOverlay: 'rgba(180,83,9,0.18)',
    accentColor: '#d97706',
    glowColor: 'rgba(217,119,6,0.7)',
  },

  // ── DEEPAVALI (2 days) ────────────────────────────────────
  {
    name: 'Deepavali',
    dates: ['11-08', '11-09'],
    emoji: ['🪔', '✨', '🎆'],
    image: '🪔',
    banner: '🪔 Happy Deepavali! May the festival of lights fill your life with joy & prosperity! ✨',
    bannerBg: 'linear-gradient(90deg, #78350f, #92400e, #b45309, #d97706, #f59e0b)',
    gradient: 'linear-gradient(90deg, #fde68a, #fbbf24, #f59e0b, #ef4444)',
    textColor: '#fff',
    particleType: 'fireworks',
    theme3d: 'deepavali',
    particles: ['🪔', '✨', '🎆', '🌟', '🎊', '⭐'],
    bgOverlay: 'rgba(180,83,9,0.2)',
    accentColor: '#f59e0b',
    glowColor: 'rgba(245,158,11,0.9)',
    isGrandFestival: true,  // extra special effects
  },

  {
  name: 'DWB Team Day',
  dates: ['05-27'],   // ← change to your actual team day date
  emoji: ['🎉', '👨‍💻', '🎊'],
  image: '👨‍💻',
  banner: '🎉 Happy DWB Team Day! Together we build, together we shine! 🌟 Proud of every member of this amazing family!',
  bannerBg: 'linear-gradient(90deg, #1a3c5e, #2563a8, #4a90d9)',
  gradient: 'linear-gradient(90deg, #7ec8f7, #4a90d9, #2563a8)',
  textColor: '#fff',
  particleType: 'confetti',
  theme3d: 'teamday',
  particles: ['🎉', '🎊', '⭐', '💙', '🌟', '🎈', '👨‍💻'],
  bgOverlay: 'rgba(37,99,168,0.2)',
  accentColor: '#4a90d9',
  glowColor: 'rgba(74,144,217,0.8)',
  isDWBSpecial: true,   // ← this triggers the falling particles + DWB badge
},
];

// ─────────────────────────────────────────────
//  Get today's MM-DD
// ─────────────────────────────────────────────
function todayMMDD() {
  const d = new Date();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${mm}-${dd}`;
}

// ─────────────────────────────────────────────
//  Main export
// ─────────────────────────────────────────────
// ── MD APPROVAL FLAG ──────────────────────────────────────
// Set to true only after MD confirms. Keep false to disable all festival banners.
const FESTIVAL_ENABLED = false;

export function getFestivalTheme() {
  if (!FESTIVAL_ENABLED) return { active: false };   // ← kills everything instantly

  const today = todayMMDD();
  const match = FESTIVALS.find(f => f.dates.includes(today));

  if (!match) return { active: false };

  return {
    active: true,
    ...match,
  };
}

export { FESTIVALS };